import AlertError from '@/components/Alerts/AlertError/AlertError.vue';

export default {
	name: 'DialogConfirmation',

	components: {
		AlertError,	
	},

    props: {
        isOpen: { type: Boolean, required: true, default: false },
        title: { type: String, required: false, default: 'Confirmação' },
        body: { type: String, required: false, default: 'Tem a certeza que quer prosseguir com esta ação?' },
        width: { type: Number, required: false, default: 600 },
        buttonName: { type: String, required: true, default: 'Submeter' },
        buttonColor: { type: String, required: false, default: 'success' },
        submitting: { type: Boolean, required: false, default: false },
        showCancelButton: { type: Boolean, required: false, default: true },
		error: { type: String, required: false, default: '' },
		humanError: { type: String, required: false, default: '' },
		boldWords: { type: Array, required: false, default: () => [] },
		showSubmitButton: { type: Boolean, required: false, default: true },
	},

  	data() {
    	return this.initialState();
	},
	
	methods: {
		initialState() {
			return {};
		},

		submit() {
            this.$emit('submit');
		},

		closeDialog() {
			this.$emit('close-dialog');
		},

		boldify(text){
			if(this.boldWords.length > 0){
				const regex = new RegExp(`(${this.boldWords.join('|')})`, 'g')
      			return text.replace(regex, '<b>$1</b>')
			}else{
				return text;
			}
		},

		toggleSubmitting() {
            this.submitting = ! this.submitting;
        }
    },
};